<!--
 * @Descripttion:
 * @Author: 杨骁锋
-->
<template>
  <div style="overflow: hidden">
    <div class="container">
      <van-popup v-model="show" style="background-color: transparent">
        <van-loading size="24px" vertical>人脸识别验证中...</van-loading>
      </van-popup>
      <div class="ranpage" style="display: block">
        <p class="plsRem">
          请记住以上<span>4位验证码</span>，录制视频时，<span
            >依次匀速朗读</span
          >
        </p>
        <div class="labelsBox">
          <p class="labels" id="ranNum" v-text="num"></p>
        </div>
      </div>
      <div class="small_tops">
        <img src="@/assets/images/lip_icon.png" alt="" />
      </div>
      <div class="bt_view">
        <div class="button" @click="beginVideo" v-if="!isPc">
          <p class="bt_text">{{ btnTip }}</p>
        </div>
        <span v-else style="font-weight: bold">人脸识别操作请在手机端完成</span>
      </div>
    </div>
    <div class="keep">
      <video id="video" autoplay></video>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import service from '@/request/api'; // 导入api接口
import { screenshotMinxin } from '@/mixins';
import { checkStatus } from '../../commonPage/mixin';

export default {
  name: 'face',
  data() {
    return {
      num: '',
      scanToken: '',
      productId: '',
      show: false,
      isPc: false,
      status: false, // 当前录制状态
      mediaRecorder: null,
      recorderFile: null,
    };
  },
  mixins: [checkStatus, screenshotMinxin],
  computed: {
    btnTip() {
      return this.status ? '停止录制' : '开始验证';
    },
  },
  created() {
    const { productId } = this.$route.query;
    this.productId = productId;
    this.getRandomNum();
    this.autoExp();
  },
  methods: {
    autoExp() {
      const np = navigator.platform;
      if (
        ['SPDB-FPD', 'SPDB-YQD', 'SPDB-PHD', 'YL-YPD'].includes(this.productId)
        && (np.indexOf('Win') === 0 || np.indexOf('Mac') === 0)
      ) {
        this.isPc = true;
      }
    },
    getRandomNum() {
      service.CommonForms.getRandomNumberOut({length:"4"}).then((res) => {
        if (res.success) {
          this.num = res.data.label;
          this.scanToken = res.data.token;
        } else {
          Toast('获取语音验证码失败！');
        }
      });
    },
    start() {
      console.log('开始录屏');
      this.mediaRecorder.start(1000);
    },
    stop() {
      console.log('结束录屏');
      this.mediaRecorder.stop();
    },
    beginVideo() {
      this.status = !this.status;
      // eslint-disable-next-line no-unused-expressions
      this.status ? this.mediaRecorder.start(1000) : this.mediaRecorder.stop();
    },
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear(); // 得到年份
      let month = now.getMonth(); // 得到月份
      let date = now.getDate(); // 得到日期
      const day = now.getDay(); // 得到周几
      let hour = now.getHours(); // 得到小时
      let minu = now.getMinutes(); // 得到分钟
      let sec = now.getSeconds(); // 得到秒
      month += 1;
      if (month < 10) month = `0${month}`;
      if (date < 10) date = `0${date}`;
      if (hour < 10) hour = `0${hour}`;
      if (minu < 10) minu = `0${minu}`;
      if (sec < 10) sec = `0${sec}`;
      const time = `${year}-${month}-${date}-${hour}-${minu}-${sec}`;
      return time;
    },
    // 兼容
    OldGetUserMedia() {
      return (
        navigator.getUserMedia
        || navigator.webkitGetUserMedia
        || navigator.mozGetUserMedia
        || navigator.msGetUserMedia
      );
    },
    // Initializes media stream.
    getUserMedia(constraints) {
      const that = this;
      if ('mediaDevices' in navigator) {
        return navigator.mediaDevices.getUserMedia(constraints);
      }
      navigator.mediaDevices = {};

      // eslint-disable-next-line no-shadow
      navigator.mediaDevices.getUserMedia = function (constraints) {
        const getUserMedia = that.OldGetUserMedia();

        // 不支持的情況下
        if (!getUserMedia) {
          return Promise.reject(
            new Error('getUserMedia is not implemented in this browser'),
          );
        }

        // 保持跟原先api一样封装成promise
        return new Promise(((resolve, reject) => {
          getUserMedia.call(navigator, constraints, resolve, reject);
        }));
      };
      return navigator.mediaDevices.getUserMedia(constraints);
    },
  },
  mounted() {
    this.autoExp();
    let chunks = [];

    const mediaStreamConstraints = {
      audio: false,
      video: {
        width: { ideal: 680 },
        height: { ideal: 680 },
        facingMode: "user"
      },
    };

    this.getUserMedia(mediaStreamConstraints)
      .then((stream) => {
        const video = document.querySelector('video');
        const getScreenshotCallback = this.getScreenshot(video);
        video.setAttribute('playsinline', true);
        video.srcObject = stream;
        video.play();

        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.ondataavailable = (e) => {
          getScreenshotCallback();
          chunks.push(e.data);
        };
        this.mediaRecorder.onstop = () => {
          console.log('停止录制');
          console.log(chunks);
          // 抓取截图start
          // 抓取截图end
          this.recorderFile = new Blob(chunks, {
            type: this.mediaRecorder.mimeType,
          });
          chunks = [];
          const dateTime = this.getCurrentDate();
          const file = new File(
            [this.recorderFile],
            `video-${dateTime}.mp4`,
            {
              type: 'video/mp4',
            },
          );
          console.log(file);
          if (file.size / 1024 / 1024 > 10) {
            Toast('视频不能超过10M,请重新上传');
            // eslint-disable-next-line consistent-return
            return false;
          }
          console.log(`文件大小：${file.size}`);
          this.show = true;
          const data = new window.FormData();
          data.append('file', file);
          data.append('label', this.num);
          if (this.screenshot.length !== 3) {
            this.show = false;
            this.screenshot = [];
            return Dialog.alert({
              message: '录制时间太短',
            }).then(() => {
              this.getRandomNum();
            });
          }
          // 抓取截图start
          this.screenshot.forEach((item) => {
            data.append('facePic', item);
          });
          // 抓取截图end
          data.append('token', this.scanToken);
          console.log(data);
          console.log(service.CommonForms.lipCheck);
          service.CommonForms.setLipCheckOut(data).then((res) => {
            console.log('人脸回调');
            console.log(res);
            if (res.success) {
              this.$router.push({
                path:'/supermarket/v2/personalCenter',
                query:{updatePhoneVerify:true}
              });

            } else {
              Dialog.alert({
                message: '人脸识别验证失败，请重新验证',
              }).then(() => {
                this.getRandomNum();
              });
            }
            this.show = false;
          });
        };
      })
      .catch((handleMediaStreamError) => {
        console.log('nosupport', handleMediaStreamError);
      });
  },
};
</script>
  <style scoped lang="scss">
.btns {
  position: absolute;
  width: 100%;
  top: 400px;
  display: flex;
  justify-content: space-around;

  span {
    background: #ff6538;
    width: 90px;
    border-radius: 4px;
    padding: 6px 0;
    color: #fff;
    font-size: 14px;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  }
}
.keep {
  position: fixed;
  width: 240px;
  height: 240px;
  top: 130px;
  left: 50%;
  margin-left: -120px;
  border: 4px solid #ff6538;
  border-radius: 100%;
  overflow: hidden;
  animation: aniKeep 1.5s linear infinite normal running;

  #video {
    object-fit: cover;
    width: 100%;
  }
}
@keyframes aniKeep {
  0% {
    box-shadow: 0px 0px 0 0px rgba(247, 100, 55, 0);
  }
  40% {
    box-shadow: 0px 0px 8px 3px rgba(247, 100, 55, 1);
  }
  60% {
    box-shadow: 0px 0px 15px 8px rgba(246, 209, 152, 0.5);
  }
  100% {
    box-shadow: 0px 0px 25px 15px rgba(246, 209, 152, 0);
  }
}

.container {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
}

/* @media screen and (min-width: 420px) {
  .container {
    position: absolute;
    top: 0;
    width: 360px;
    height: 640px;
    overflow: hidden;
    background: #030e27;
  }
} */

/** 按钮view **/
.bt_view {
  position: absolute;
  bottom: 60px;
  width: 100%;
  height: 100px;
  text-align: center;
}

/** button **/
.button {
  display: block;
  width: 80%;
  height: 44px;
  margin: 0 auto;
  margin-top: 12%;
  line-height: 44px;
  background-image: linear-gradient(-180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 2em;
  border-radius: 8px;
}

.bt_text {
  color: #fff;
  font-size: 17px;
}

.bg {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
}

.ranpage {
  position: absolute;
  top: 25px;
  box-sizing: border-box;
  width: 100%;
  height: 45%;
  text-align: center;
  background: #f5f5f5;
}

.small_tops {
  position: absolute;
  top: 400px;
  width: 100%;
  height: 63px;
  text-align: center;
}

.small_tops img {
  width: 90%;
  height: 100%;
}

.labelsBox {
  width: 90%;
  height: 140px;
  margin: 10px auto 0 auto;
  color: #ff6538;
  font-size: 40px;
  letter-spacing: 0.2em;
  p {
    margin: 0;
    font-weight: bold;
  }
}

.plsRem {
  color: #525867;
  font-size: 12px;
  letter-spacing: 0;
}

.plsRem span {
  color: #00121a;
}
</style>
